import { render, staticRenderFns } from "./font-awesome.vue?vue&type=template&id=de18d434&"
import script from "./font-awesome.vue?vue&type=script&lang=js&"
export * from "./font-awesome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports